<!--
  +---------------------------------------------------------------------------------------
  | @Author:    chris<jiangqingqing@frippler.com>
  | @Title:     设备增值-收费方案详情
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="ei-scheme-detail">
    <div class="main-header">
      <div class="title">
        <f-back />
        <span v-if="schemeid">{{ $route.meta.title }}</span>
        <span v-else>收费方案添加</span>
      </div>
      <div class="toolbox">
        <el-button v-if="schemeid" type="danger" plain @click="deletePlan">删除</el-button>
      </div>
    </div>
    <el-card shadow="never">
      <div style="display: flex;">
        <div class="preview">
          <div class="header">
            <span>方案示例</span>
          </div>
          <div
            class="body"
            :style="{backgroundImage: `url(${require(profile.activity_params.advanced_price_enable && advance_show ? '../../assets/scheme-ladder.jpg' : '../../assets/scheme-default.jpg')})`}"
          >
            <div v-if="!profile.activity_params.advanced_price_enable || !advance_show" class="wechat flex">
              <div class="bd title text-black font-lg ellipsis">{{ profile.title }}</div>
              <div
                v-if="profile.activity_enable && profile.activity_params.title && advance_show"
                class="ft activityTitle text-white"
              >{{ profile.activity_params.title }}</div>
            </div>
            <div
              v-if="profile.activity_enable && advance_show && !profile.activity_params.advanced_price_enable"
              class="deadline text-black"
            >活动截止: {{ profile.activity_params.endtime | parseTime('{y}/{m}/{d} {h}:{i}:{s}') }}</div>

            <div v-if="!profile.activity_params.advanced_price_enable" class="price text-black">
              <div v-if="profile.activity_enable && profile.activity_params.discount_price && advance_show" class="originalPrice1 ml-xs">
                <span>￥{{ profile.scheme_price }}{{profile.scheme_unit === 'year'?'/年':profile.scheme_unit === 'month'?'/月':'/一次性'}}</span>
              </div>
              <div v-else class="originalPrice2">
                <span style="font-size: 32px;font-weight: normal;">￥{{ profile.scheme_price }}</span>
                <span v-if="profile.scheme_unit === 'year'">/年</span>
              </div>

              <div v-if="profile.activity_enable && profile.activity_params.discount_price && advance_show" class="discount">
                <span style="font-size: 32px;font-weight: normal;">{{ profile.activity_params.discount_price }}</span>
                <span v-if="profile.scheme_unit === 'year'">/年</span>
              </div>
            </div>
            <div v-if="!advance_show" class="price text-black">
              <div class="originalPrice2">
                <span style="font-size: 32px;font-weight: normal;">￥{{ profile.scheme_price }}</span>
                <span v-if="profile.scheme_unit === 'year'">/年</span>
              </div>
            </div>
            <div v-if="profile.activity_params.advanced_price_enable && advance_show" class="price_ladder">
              <div class="ladder_item">
                <div class="flex column justify-content-center mt">
                  <div class="" style="font-size: 16px;">{{ '1年' }}</div>
                  <div class="mt-xs mb-xs discount-price ellipsis" ><span v-if="profile.activity_params.advanced_prices.one_year">￥</span>{{ profile.activity_params.advanced_prices.one_year || '--' }}</div>
                  <div class="text-muted line-though" style="font-size: 11px;">￥{{ profile.scheme_price }}</div>
                </div>
                <div v-if="profile.activity_params.advanced_prices.one_year" class="save ellipsis">
                  已优惠 <span class="">{{ profile.scheme_price - profile.activity_params.advanced_prices.one_year }}</span>
                </div>
              </div>
              <div class="ladder_item">
                <div class="flex column justify-content-center mt">
                  <div class="" style="font-size: 16px;">{{ '2年' }}</div>
                  <div class="mt-xs mb-xs discount-price ellipsis"><span v-if="profile.activity_params.advanced_prices.two_year">￥</span>{{ profile.activity_params.advanced_prices.two_year * 2 || '--' }}</div>
                  <div class="text-muted line-though" style="font-size: 11px;">￥{{ profile.scheme_price * 2 }}</div>
                  <div v-if="profile.activity_params.advanced_prices.two_year" class="save ellipsis">
                    已优惠 <span class="">{{ (profile.scheme_price - profile.activity_params.advanced_prices.two_year) * 2 }}</span>
                  </div>
                </div>
              </div>
              <div class="ladder_item">
                <div class="flex column justify-content-center mt">
                  <div class="" style="font-size: 16px;">{{ '3年' }}</div>
                  <div class="mt-xs mb-xs discount-price ellipsis"><span v-if="profile.activity_params.advanced_prices.three_year">￥</span>{{ profile.activity_params.advanced_prices.three_year * 3 || '--' }}</div>
                  <div class="text-muted line-though" style="font-size: 11px;">￥{{ profile.scheme_price * 3 }}</div>
                </div>
                <div v-if="profile.activity_params.advanced_prices.three_year" class="save ellipsis">
                  已优惠 <span class="">{{ (profile.scheme_price - profile.activity_params.advanced_prices.three_year) * 3 }}</span>
                </div>
              </div>
            </div>

            <div v-if="!profile.activity_enable || (profile.activity_enable && !advance_show)" class="total">
              <span style="font-size:16px">应付：</span>
              <span style="font-size: 28px;color: #07c160;">￥{{ profile.scheme_price }}</span>
            </div>
            <div v-else class="total2">
              <div>
                <span style="font-size:16px">应付：</span>
                <span style="font-size: 28px;color: #07c160;">￥{{ profile.activity_params.discount_price }}</span>
              </div>
              <div style="font-size:14px;color:rgba(194, 91, 96, 1)">
                <span>共减</span>
                <span class="ml">￥{{ (profile.scheme_price - profile.activity_params.discount_price).toFixed(2) }}</span>
              </div>
            </div>
          </div>
        </div>
        <div style="flex: auto;">
          <el-tabs v-model="activeTab" type="card">
            <el-tab-pane label="基本信息" name="basic">
              <basic :type="type" @show="formShow" @change="changeBasic" @update="updateSchemeid" />
            </el-tab-pane>
            <el-tab-pane v-if="schemeid" label="通知设置" name="notice">
              <notice />
            </el-tab-pane>
            <el-tab-pane v-if="schemeid" label="数据分析" name="statistic">
              <DataStatistic />
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getSchemeDetailApi, delSchemeApi } from "@/api/ei/eiApi";

export default {
  name: "EiSchemeDetail",

  components: {
    Basic: () => import("@/views/ei/components/EiSchemeBasic"),
    Notice: () => import("@/views/ei/components/EiSchemeNotice"),
    DataStatistic: () => import("@/views/ei/components/DataStatistic"),
  },

  data() {
    return {
      basicFormShow: false,
      schemeid: this.$route.query.schemeid
        ? parseInt(this.$route.query.schemeid)
        : undefined,
      type: this.$route.query.type ? parseInt(this.$route.query.type) : 0,
      activeTab: "basic",
      time: parseInt(new Date().valueOf() / 1000),
      profile: {
        title: "",
        scheme_unit: "year",
        scheme_price: 0,
        activity_enable: 0,
        activity_params: {
          advanced_prices: {
            one_year: 0,
            two_year: 0,
            three_year: 0,
          },
        },
      },
    };
  },

  computed: {
    god() {
      return this.$store.state.godStore;
    },
    advance_show() {
      return this.basicFormShow ||
        (!this.basicFormShow &&
          this.profile.activity_params.endtime &&
          this.time < this.profile.activity_params.endtime &&
          this.time > this.profile.activity_params.starttime)
        ? true
        : false;
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      if (!this.schemeid) {
        return;
      }
      getSchemeDetailApi({ schemeid: this.schemeid }).then((res) => {
        if (!res.errno) {
          if (
            res.data.profile.scheme_unit == "year" &&
            Object.keys(res.data.profile.activity_params).length == 0
          ) {
            const advanced_prices = {
              one_year: 0,
              two_year: 0,
              three_year: 0,
            };
            const activity_params = {};
            const temp1 = Object.assign(activity_params, { advanced_prices });
            this.profile = Object.assign({}, res.data.profile, {
              activity_params: temp1,
            });
          }
          this.profile.title = res.data.profile.title;
          this.profile.scheme_unit = res.data.profile.scheme_unit;
          this.profile.scheme_price = res.data.profile.scheme_price;
          this.profile.activity_enable = res.data.profile.activity_enable;
          this.profile.activity_params = Object.assign(
            {},
            res.data.profile.activity_params
          );
        } else {
          this.$message.error(res.message);
        }
      });
    },
    formShow(show) {
      this.basicFormShow = show;
    },
    updateSchemeid(id) {
      this.schemeid = id;
    },
    changeBasic(basic) {
      if (basic.unit == "year" && !basic.two_year) {
        const advanced_prices = {
          one_year: 0,
          two_year: 0,
          three_year: 0,
        };
        const activity_params = {};
        const temp1 = Object.assign(activity_params, { advanced_prices });
        this.profile = Object.assign(this.profile, { activity_params: temp1 });
      }
      this.profile.title = basic.title;
      this.profile.scheme_unit = basic.unit;
      this.profile.scheme_price = basic.scheme_price;
      this.profile.activity_enable = basic.activity_enable;
      this.$set(this.profile.activity_params, "title", basic.name);
      this.$set(this.profile.activity_params, "starttime", basic.starttime);
      this.$set(this.profile.activity_params, "endtime", basic.endtime);
      this.$set(
        this.profile.activity_params,
        "discount_price",
        basic.discount_price
      );
      this.$set(
        this.profile.activity_params,
        "advanced_price_enable",
        basic.advanced_price_enable
      );
      if (basic.unit == "year") {
        this.$set(
          this.profile.activity_params.advanced_prices,
          "one_year",
          basic.discount_price
        );
        this.$set(
          this.profile.activity_params.advanced_prices,
          "two_year",
          basic.two_year
        );
        this.$set(
          this.profile.activity_params.advanced_prices,
          "three_year",
          basic.three_year
        );
      }
    },

    deletePlan() {
      const msg = "此操作将永久删除该方案，是否继续?";
      this.$confirm(msg, "提示", {
        type: "warning",
      }).then(() => {
        const temp = Array.of(this.schemeid);
        delSchemeApi({ schemeids: temp }).then((res) => {
          if (res.errno === 0) {
            this.$message.success(res.message);
            this.$router.go(-1);
            return;
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ei-scheme-detail {
  .preview {
    width: 350px;
    margin: 0px 100px 40px 50px;
    .header {
      line-height: 40px;
      text-align: center;
    }
    .body {
      position: relative;
      width: 350px;
      height: 768px;
      border: 1px solid rgba(0, 0, 0, 0.05);
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      background-size: cover;
      background-repeat: no-repeat;
      .wechat {
        margin-top: 205px;
        margin-left: 30px;
        margin-right: 30px;
        // align-items: center;
        // justify-content: space-between;
        .title {
          font-weight: bold;
          line-height: 25px;
        }
      }
      .activityTitle {
        position: relative;
        right: -16px;
        top: -12px;
        padding: 0 10px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        font-size: 14px;
        border-radius: 0px 10px 0px 10px;
        background: linear-gradient(to right, #ff7400, #ffae0c);
      }
      .deadline {
        margin-left: 30px;
        margin-top: 0px;
        font-size: 14px;
      }
      .promotion {
        margin-top: 10px;
        margin-left: 40px;
        margin-right: 30px;
        font-size: 14px;
      }
      .price {
        position: absolute;
        top: 325px;
        right: 30px;
        font-weight: bold;
        .originalPrice1 {
          text-decoration: line-through;
          font-size: 14px;
          opacity: 0.5;
          color: rgba(16, 16, 16, 1);
          margin-bottom: 5px;
        }
        .originalPrice2 {
          margin-top: 20px;
          font-size: 14px;
          line-height: 40px;
        }
        .discount {
          vertical-align: baseline;
        }
      }
      .price_ladder {
        position: absolute;
        top: 204px;
        right: 15px;
        width: 320px;
        height: 130px;
        display: flex;
        .ladder_item {
          width: 96px;
          margin: 0 8px; /* 两两间隔 */
          text-align: center;
          position: relative;
          .discount-price {
            font-size: 20px;
            height: 35px;
            line-height: 35px;
            padding: 0 8px;
          }
          .line-though {
            text-decoration: line-through;
          }
          .save {
            position: absolute;
            bottom: 2px;
            height: 24px;
            line-height: 24px;
            padding: 0 8px;
            width: 96px;
            color: #12C467;
          }
        }
        .ladder_item:first-child {
          margin-left: 0;
        }
        .ladder_item:last-child {
          margin-right: 0;
        }
      }
      .total {
        position: absolute;
        bottom: 15px;
        left: 20px;
      }
      .total2 {
        position: absolute;
        bottom: 5px;
        left: 20px;
      }
    }
    .el-scrollbar {
      height: 508px;
      > .el-scrollbar__wrap {
        overflow-x: hidden;
        > .el-scrollbar__view {
          padding: 0 0 0 0;
        }
      }
    }
  }
}
</style>